// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.WithNavigator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * This HOC supports to register and unregister event handlers.
 * Use it with recompose module
 *
 * import { compose } from 'recompose';
 * import withNavigator from 'share/components/hoc/Izenda.WithNavigator';
 *
 * compose(
 *   withNavigator({
 *    onMyEvent: () => { // register handler },
 *    // others
 *   })
 * )
 */

import React, { Component } from 'react';
import { isNil, findIndex, isFunction, find } from 'lodash/fp';

const events = [
  {
    name: 'onbeforeunload',
    isWindowEvent: true
  },
  {
    name: 'onpagehide',
    isWindowEvent: true
  },
  {
    name: 'onpageshow',
    isWindowEvent: true
  },
  {
    name: 'onlistenbefore', // react-router event
    isWindowEvent: false
  }
];

class EventHandler {
  constructor(eventName: string, handlerFn: any) {
    this.eventName = eventName;
    this.setHander(handlerFn);
  }

  /**
   * Register handler
   * @param {Object} handlerFn
   */
  setHander(handlerFn: any): void {
    if (isFunction(handlerFn)) {
      if (this.isWindowEvent()) {
        this.restoreFn = window[this.eventName];
        window[this.eventName] = handlerFn();
      } else {
        this.restoreFn = handlerFn();
      }
    }
  }

  /**
   * Reset handler
   */
  restoreHandler(): void {
    this.restoreFn && this.restoreFn();
  }

  /**
   * Check this is a window's event
   */
  isWindowEvent(): boolean {
    return findIndex(e => e.name === this.eventName && e.isWindowEvent, events) !== -1;
  }
}

const withNavigator = spec => BaseComponent => {
  class Navigator extends Component {
    constructor(props) {
      super(props);

      this.handlers = [];
      Object.keys(spec).forEach(hook => {
        const matchingEvent = find(e => e.name === hook, events);
        !isNil(matchingEvent) && this.handlers.push(new EventHandler(matchingEvent.name, spec[hook].bind(this)));
      });
    }

    componentWillUnmount() {
      this.handlers.forEach(h => h.restoreHandler());
    }

    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  return Navigator;
};

export default withNavigator;



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.WithNavigator.js